// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1diyP","footer":"ModalCreateQualiphyProcedure_footer__T98nB","additionData":"ModalCreateQualiphyProcedure_additionData__2n7Eu"};